// Imports
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import dayjs from "dayjs";
// UI Imports
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from "@mui/material/Checkbox"
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core'
import Switch from '@mui/material/Switch';
import { RestartAlt } from "@mui/icons-material";
import styles from './styles'

// App Imports
import { messageShow } from '../../common/api/actions'
import SectionPaper from '../../common/SectionPaper'
import BrandedLoading from '../../common/BrandedLoading'
import EmptyMessage from '../../common/EmptyMessage'
import Pagination from '../../common/Pagination'
import ImageComp from '../../common/Image'
import { listVendors } from '../../user/api/actions/query'
import { vendorData } from '../../common/Header';
import { publishToggleVendor, removeVendor } from '../../user/api/actions/mutation'
import routes from '../api/routes'
import { getImageSource } from '../../user/api/routes'
import { store } from "../../../setup/store";
import { onResetStocks } from "../../product/api/actions/mutation";
import { updateSettings } from "../../setting/api/actions/mutation";
import { UPDATE_SETTING_SUCCESS } from "../../setting/api/actions/types";
import { checkPermission } from "../../common/Sidebar/checkPermission";

// Component
class List extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      vendors: vendorData,
      count: 0,
      resumeOrder: false,
      permissions:{
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
      resumeOrderPermissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
      resetStockPermissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      }
    }
  }

  componentDidMount() {
    this.verifyPermissions();
    const {settings} = this.props;
    if (this.state.vendors.length === 0) {
      this.fetchVendors();
    }
    if (settings?.settings?.resumeOrder !== undefined) {
     this.setState({ resumeOrder: settings.settings.resumeOrder });
    }
  }
 
  componentDidUpdate(prevProps) {
    const { settings } = this.props;
    if (
      settings?.settings?.resumeOrder !== prevProps.settings?.settings?.resumeOrder &&
      settings?.settings?.resumeOrder !== this.state.resumeOrder
    ) {
      this.setState({ resumeOrder: settings.settings.resumeOrder });
    }
  }

  verifyPermissions = async () =>{
      const modulePermissions =await checkPermission("utilities","");
      this.setState({permissions:{canView:modulePermissions.canView,canCreate:modulePermissions.canCreate,canEdit:modulePermissions.canEdit,canDelete:modulePermissions.canDelete}});
      const resumeOrderPermission = await checkPermission("utilities", "storeSettings.resumeOrders");
      this.setState({resumeOrderPermissions:{canEdit:resumeOrderPermission.canEdit,canDelete: resumeOrderPermission.canDelete,canCreate: resumeOrderPermission.canCreate,canView: resumeOrderPermission.canView}});
      const resetStockPermission = await checkPermission("utilities", "storeSettings.resetStock");
      this.setState({resetStockPermissions:{canEdit:resetStockPermission.canEdit,canDelete: resetStockPermission.canDelete,canCreate: resetStockPermission.canCreate,canView: resetStockPermission.canView}});
  }

  fetchVendors = async () => {
    const { listVendors, messageShow } = this.props
    this.setState({ isLoading: true })

    try {
      const { data } = await listVendors({ page:1 })

      if(data.success) {
        this.setState({
          vendors: data.data.list,
          count: data.data.count
        })
      } else {
        messageShow(data.message)
      }
    } catch(error) {
      messageShow('There was some error. Please try again.')
    } finally {
      this.setState({isLoading:false})
    }
  }

  refresh = () => {
    this.setState({
      isLoading: true 
    })
    this.fetchVendors()
  }

  onPublishToggle = vendorId => async event => {
    const isPublished = event.target.checked

    let check = window.confirm(`Are you sure you want to ${ isPublished ? 'publish' : 'unpublish' } this vendor?`)

    if(check) {
      const { publishToggleVendor, messageShow } = this.props

      try {
        const { data } = await publishToggleVendor({ vendorId, isPublished })

        messageShow(data.message)

        if(data.success) {
          this.refresh(false)
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }

  onDelete = (vendorId) => async () => {
    let check = window.confirm('Are you sure you want to delete this vendor?')

    if(check) {
      const { removeVendor, messageShow } = this.props

      try {
        const { data } = await removeVendor({ vendorId })

        messageShow(data.message)

        if(data.success) {
          this.refresh(false)
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }

  handleResumeToggle = async (event) => {
    const resumeOrder = event.target.checked
    const { updateSettings, messageShow } = this.props;
    const { data } = await updateSettings({requestObject: { resumeOrder }});
    if(data.success){
       this.setState({ resumeOrder })
       store.dispatch({
        type: UPDATE_SETTING_SUCCESS,
        payload: { resumeOrder },
      });
      messageShow(resumeOrder ? "Orders have been resumed successfully." : "Orders have been paused successfully.")
    }else{
      messageShow("Something went wrong while updating order status.")
    }
  
  }

  handleRestoreStocks = async () => {
    try {
      const { onResetStocks, messageShow } = this.props;
      const result = await onResetStocks();
      messageShow(result?.data?.message);
    } catch (error) {
      messageShow("There was some error. Please try again.");
    }
  }

  render() {
    const { classes, settings } = this.props
    const { isLoading, vendors, count, resumeOrder, permissions, resumeOrderPermissions, resetStockPermissions } = this.state
   
    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Account
          </Typography>
          <Tooltip title="Refresh" arrow>
            <Button onClick={this.refresh} color="primary">
              <RefreshIcon />
            </Button>
          </Tooltip>
        </Toolbar>

        <SectionPaper>
          {
            isLoading
              ? <BrandedLoading />
              : vendors.length === 0
                ? <EmptyMessage message={'No vendors to show.'} />
                : <>
                    <Table padding={"normal"}>
                      <TableHead>
                        <TableRow>
                          <TableCell width={85}>Image</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell width={130}>Mobile</TableCell>
                          <TableCell width={180}>Joined</TableCell>
                          <TableCell width={80} align="center">Published</TableCell>
                          <TableCell width={90} align="center">Actions</TableCell>
                          <TableCell width={90} align="center">Settings</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {
                          vendors.map(({ _id, image, name, mobile, email, isPublished, createdAt }) =>
                            <TableRow key={_id}>
                              <TableCell>
                                <Link to={routes.vendorUpdate.path(_id)}>
                                <ImageComp
                                  src={getImageSource(`${image}`)}
                                  defaultSrc={getImageSource()}
                                />
                                </Link>
                              </TableCell>
                              <TableCell>
                                <Link to={routes.vendorUpdate.path(_id)}>
                                  {name}
                                </Link>
                              </TableCell>
                              <TableCell>{ email }</TableCell>
                              <TableCell>{ mobile }</TableCell>
                              <TableCell>{dayjs(createdAt).format("DD-MM-YYYY, hh:mm A")}</TableCell>
                              <TableCell align="center">
                                <Checkbox
                                  checked={isPublished}
                                  disabled={!permissions.canEdit}
                                  onChange={this.onPublishToggle(_id)}
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title="Delete" arrow>
                                  <Button
                                   color="error" 
                                   disabled={!permissions.canDelete}
                                   onClick={this.onDelete(_id)}><DeleteIcon /></Button>
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title="Settings" arrow>
                                  <IconButton 
                                    sx={{ color: '#0d3559' }}
                                    component={Link} 
                                    to={`/settings/${_id}`}
                                  >
                                    <SettingsIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          )
                        }
                      </TableBody>
                    </Table>

                    <Pagination
                      count={vendors.length}
                      route={routes.vendorList}
                    />
                  </>
          }
        </SectionPaper>
        {settings?.settings?.isStoreSubscribed && 
        (resumeOrderPermissions.canView || resetStockPermissions.canView) && (
        <div className={classes.controlContainer}>
          {resumeOrderPermissions.canView && (
          <div className={classes.controlRow}>
            <Typography
              variant="subtitle1"
              className={classes.controlLabel}
            >
              Resume Orders
            </Typography>
           <Switch
              checked={resumeOrder}
              onChange={this.handleResumeToggle}
              color="primary"
           />
           <Typography
              variant="body2"
              className={classes.controlStatus}
              style={{ color: resumeOrder ? '#2e7d32' : '#999'}}
            >
              {resumeOrder ? 'Orders are active' : 'Orders are paused'}
            </Typography>
          </div>
          )}
          {resetStockPermissions.canView && (
          <div className={classes.controlRow}>
            <Typography
              variant="subtitle1"
              className={classes.controlLabel}
            >
              Restore Stocks
            </Typography>
            <Button
              variant="contained"
              startIcon={<RestartAlt />}
              onClick={this.handleRestoreStocks}
              style={{ textTransform: 'none'}}
            >
              Restore
            </Button>
          </div>
          )}
        </div>
        )}
      </div>
    )
  }
}

// Component Properties
List.propTypes = {
  listVendors: PropTypes.func.isRequired,
  publishToggleVendor: PropTypes.func.isRequired,
  removeVendor: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  onResetStocks: PropTypes.object.isRequired,
  updateSettings: PropTypes.func.isRequired,
}

// Component State
function listState(state) {
  return {
    settings: state.settings,
  }
}

export default connect(listState, { listVendors, publishToggleVendor, removeVendor, onResetStocks, updateSettings, messageShow })(withStyles(styles)(List))
